;(function($, window, document, undefined) {
    /**
     * @class Postcode API.
     * @param {HTMLElement} element - The element of the Postcode API.
     * @param {Array} options - The options of the Postcode API.
     */
    function PostcodeApi(element, options) {
        /**
         * Plugin element of the Postcode API.
         */
        this.$element = $(element);

        /**
         * Current settings for the Postcode API.
         */
        this.settings = $.extend({}, PostcodeApi.Defaults, options);

        /**
         * The fields of the zipcode form.
         */
        this.fields = {};

        this.initialize();
    }

    /**
     * Default options for the Postcode API.
     */
    PostcodeApi.Defaults = {
        attr: 'data-postcode-api'
    };

    /**
     * Initializes the Postcode API.
     */
    PostcodeApi.prototype.initialize = function() {
        this.setFields();
    };

    /**
     * Sets the fields to validate a zipcode.
     */
    PostcodeApi.prototype.setFields = function() {
        $('[' + this.settings.attr + ']', this.$element).each($.proxy(function(index, field) {
            var $field  = $(field);
            var type    = $field.attr(this.settings.attr);

            if (['zipcode', 'housenumber', 'housenumber_addition'].indexOf(type) !== -1) {
                $field.on('keyup', $.proxy(this.onHandleField, this));
            }

            this.fields['$' + type] = $field;
        }, this));
    };

    /**
     * Handles a field to validate a zipcode.
     */
    PostcodeApi.prototype.onHandleField = function() {
        var zipcode = this.getValidZipcode();
        var housenumber = this.getValidHousenumber();

        if (zipcode && housenumber) {
            $.ajax({
                url         : '/assets/components/postcodeapi/connector.php?action=web/get&zipcode=' + zipcode + '&housenumber=' + housenumber[0] + '&housenumber_addition=' + (housenumber[1] || ''),
                cache       : false,
                dataType    : 'JSON',
                complete    : $.proxy(function (result) {
                    if (result.responseJSON.results) {
                        for (var key in this.fields) {
                            var $field  = this.fields[key];
                            var type    = key.substring(1);

                            if (['zipcode', 'housenumber', 'housenumber_addition'].indexOf(type) === -1) {
                                if (result.responseJSON.results[type]) {
                                    $field.val(result.responseJSON.results[type]).trigger('change');
                                } else {
                                    $field.val('').trigger('change');
                                }
                            }
                        }
                    }
                }, this)
            });
        }
    };

    /**
     * Validate the zipcode.
     *
     * @return Boolean|String.
     */
    PostcodeApi.prototype.getValidZipcode = function() {
        if (this.fields.$zipcode) {
            var regex = this.fields.$zipcode.val().match(/^([1-9][0-9]{3}) ?((?!sa|sd|ss)[a-z]{2})$/i);

            if (regex && regex[1] && regex[2]) {
                return regex[1] + ' ' + regex[2].toUpperCase();
            }
        }

        return false;
    };

    /**
     * Validate the housenumber.
     *
     * @return Boolean|Array.
     */
    PostcodeApi.prototype.getValidHousenumber = function() {
        if (this.fields.$housenumber) {
            if (this.fields.$housenumber_addition) {
                // @TODO function to validate housenumber and housenumber addition in separated fields.
            } else {
                var regex = this.fields.$housenumber.val().match(/^([0-9]+)([- ]?)(([a-z0-9]+)?)$/i);

                if (regex && regex[1] && regex[3]) {
                    return [regex[1], regex[3]];
                } else if (regex && regex[1]) {
                    return [regex[1]];
                }
            }
        }

        return false;
    };

    /**
     * The jQuery Plugin for the Postcode API.
     */
    $.fn.PostcodeApi = function(option) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function() {
            var $this = $(this),
                data = $this.data('postcodeapi');

            if (!data) {
                data = new PostcodeApi(this, typeof option === 'object' && option);

                $this.data('postcodeapi', data);
            }

            if (typeof option === 'string' && option.charAt(0) !== '_') {
                data[option].apply(data, args);
            }
        });
    };

    /**
     * The constructor for the Postcode API.
     * @public.
     */
    $.fn.PostcodeApi.Constructor = PostcodeApi;
})(window.Zepto || window.jQuery, window, document);